/**
 * Reads the S3 key an asset URL points at, dropping origin, signature and
 * hash — the one part of the URL that stays the same across re-signing.
 *
 * @param url - Asset URL, signed or bare.
 * @returns The key, or the input unchanged when it is not a URL.
 */
export const getKeyFromUrl = (url: string): string => {
  try {
    return new URL(url).pathname.replace(/^\/+/, '');
  } catch {
    return url;
  }
};

/** The `{uuid}-` the upload presign puts in front of every file name. */
const UPLOAD_ID_PREFIX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i;

/**
 * Reads the name the author's file had before it was uploaded.
 *
 * @param url - Asset URL, signed or bare.
 * @returns The file name, or the input when it is not a URL.
 */
export const assetFileName = (url: string): string => {
  const segment = getKeyFromUrl(url).split('/').pop() ?? '';

  try {
    return decodeURIComponent(segment).replace(UPLOAD_ID_PREFIX, '');
  } catch {
    return segment.replace(UPLOAD_ID_PREFIX, '');
  }
};
